
import React, { Component } from 'react';
import NewsPageTagsComponent from '../../components/news/containers/NewsPageTagsContainer';
import { getDataNewsByTagIfNeeded } from '../../components/news/actions/NewsActions';

class NoticiasTags extends Component {
    static fetchData(store, match) {
        const myPromises = [
            store.dispatch(getDataNewsByTagIfNeeded(12, 0, match.params.slug)),
        ];

        return Promise.all(myPromises);
    }

    render() {
        return (
            <div className="tw-container tw-m-auto tw-px-5">
                <NewsPageTagsComponent />
            </div>
        );
    }
}

export default NoticiasTags;
